"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var SinglePayeeView = function SinglePayeeView(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-revisor__payees"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-revisor__payee-name revisions-revisor__payee-name--single-view"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Plan Amount:"), children));
};
SinglePayeeView.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = SinglePayeeView;
exports.default = _default;
